import { FormValues } from '@/containers/ConfigurePage/components/FormConfig/formData';

export const getCurrentSubscriptionIsFlexible = (
  durationMonths?: FormValues['durationMonths']
): boolean => {
  return durationMonths === '1';
};
